import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { theme } from '../theme';
const Avatar = ({ firstName, lastName }) => {
    const getInitials = (first, last) => {
        const firstInitial = first.charAt(0).toUpperCase();
        const lastInitial = last.charAt(0).toUpperCase();
        return `${firstInitial}${lastInitial}`;
    };
    const initials = getInitials(firstName, lastName);
    return (<View style={styles.avatarContainer}>
      <Text style={styles.avatarText}>{initials}</Text>
    </View>);
};
const styles = StyleSheet.create({
    avatarContainer: {
        width: 100,
        height: 100,
        borderRadius: 128,
        backgroundColor: theme.colors.avatarBackground,
        justifyContent: 'center',
        alignItems: 'center',
    },
    avatarText: {
        color: theme.colors.textOnPrimary,
        fontSize: 48,
        fontWeight: 'bold',
    },
});
export default Avatar;
